RivalIQ.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.TableView = Marionette.CollectionView.extend({
        tagName: 'table',
        className: 'table',

        childView: views.TablePart,

        childViewOptions: function (model) {

            return model.toJSON();
        },

        initialize: function () {

            const me = this;
            const parts = _.compact([me.getHeader(), me.getBody(), me.getFooter()]);
            me.collection = new Backbone.Collection(parts);
        },

        getHeader: function () {

            const me = this;
            const options = _.extend({}, me.options);
            const header = options.header;

            if (header) {

                return {
                    isHeader: true,
                    tagName: 'thead',
                    rows: header.rows
                };
            }
        },

        getBody: function () {

            const me = this;
            const options = _.extend({}, me.options);
            const body = options.body;

            if (body) {

                return {
                    rows: body.rows,
                    tagName: 'tbody',
                    limit: (body.limit || Infinity)
                };
            }
        },

        getFooter: function () {

            const me = this;
            const options = _.extend({}, me.options);
            const footer = options.footer;

            if (footer) {

                return {
                    tagName: 'tfoot',
                    rows: footer.rows
                };
            }
        },

        sort: function (fn) {

            const me = this;

            me.children.each(function (child) {

                const collection = child.collection;

                collection.comparator = function (a, b) {

                    return fn(a.get('data'), b.get('data'));
                };

                collection.sort();
            });
        }
    });

});
